import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { Grid, Stack } from "@mui/material";
import UserImage from "../../../../components/UserImage";
import { ASSETS } from "../../../../utils/config";

function GalleryLoader() {
  const renderProfileLoader = () => {
    return (
      <>
        <Stack m={1} mb={3}>
          <Stack
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"flex-start"}
            pl={2}
            my={1}
          >
            <UserImage />
            <Stack>
              <Skeleton
                variant="rect"
                width={"60vw"}
                height={14}
                style={{ borderRadius: "4px", marginLeft: 15, marginTop: 7 }}
              />
              <Skeleton
                variant="rect"
                width={"40vw"}
                height={14}
                style={{ borderRadius: "4px", marginLeft: 15, marginTop: 7 }}
              />
            </Stack>
          </Stack>
          {[1, 2, 3, 4, 5].map((e) => (
            <Skeleton
              variant="rect"
              width={e % 2 ? "34vw" : "74vw"}
              height={9}
              style={{ borderRadius: "10px", marginLeft: 15, marginTop: 5 }}
            />
          ))}
          <Skeleton
            variant="rect"
            width={"60vw"}
            height={14}
            style={{ borderRadius: "2px", marginLeft: 15, marginTop: 7 }}
          />
          <Stack
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"flex-start"}
            ml={2}
            mt={1}
          >
            {[1, 2, 3, 4, 5].map((e) => (
              <Skeleton
                variant="rect"
                width={30}
                height={30}
                style={{ borderRadius: "15px", marginRight: 15 }}
              />
            ))}
          </Stack>
        </Stack>
      </>
    );
  };
  const renderMainWheelLoader = () => {
    return (
      <>
        <Stack
          style={{
            cursor: "pointer",
            borderRadius: "10px",
            margin: "10px",
            width: "91vw",
            backgroundColor: "white",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
          }}
        >
          <img
            alt="loading"
            src={ASSETS.Mwheelloader}
            style={{ height: "25vh", width: "45vw" }}
          />
        </Stack>
        <Skeleton
          variant="rect"
          width={"90vw"}
          height={35}
          style={{ borderRadius: "4px", marginLeft: "2.5vw", marginTop: 7 }}
        />
      </>
    );
  };
  const renderWheelsLoader = () => {
    return (
      <>
        <Skeleton
          variant="rect"
          width={"40vw"}
          height={20}
          style={{ borderRadius: "4px", marginLeft: "2.5vw", marginTop: 7 }}
        />
        <Stack>
          <Grid container sx={{ py: 2 }}>
            {[1, 2, 3, 4].map((item, index) => (
              <Grid item xs={6} sm={6} key={index}>
                <Stack
                  style={{
                    marginBottom: "3px",
                    border: "1px solid #E1E1E1",
                    borderRadius: "10px",
                    margin: "5px",
                    width: "40vw",
                    height: "26vh",
                    position: "relative",
                    backgroundColor: "white",
                    boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Skeleton
                    variant="rect"
                    width={"25vw"}
                    height={11}
                    style={{
                      borderRadius: "4px",
                      marginLeft: "2.5vw",
                      marginTop: 8,
                    }}
                  />
                  <Skeleton
                    variant="rect"
                    width={"17vw"}
                    height={11}
                    style={{
                      borderRadius: "4px",
                      marginLeft: "2.5vw",
                      marginTop: 4,
                    }}
                  />
                  <Skeleton
                    variant="rect"
                    width={"90%"}
                    height={"15vh"}
                    style={{
                      borderRadius: "4px",
                      marginLeft: "2.5vw",
                      marginTop: 8,
                    }}
                  />
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </>
    );
  };

  return (
    <Stack sx={{ width: "95vw", ml: "2.5vw" }}>
      {renderProfileLoader()}
      {renderMainWheelLoader()}
      {renderWheelsLoader()}
    </Stack>
  );
}

export default GalleryLoader;
